export default __webpack_public_path__ + "static/media/LoadingImage.7a06dd7e.svg";